import { useEffect, useState } from 'react';

function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const windowHeight = window.innerHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Controls button visibility after scrolling past the viewport height.
      setIsVisible(scrollTop > (windowHeight / 4));

      // Adjust positioning relative to footer when visible
      const btn = document.querySelector('.upward button');
      const footer = document.querySelector('footer');
      if (!btn || !footer) return;

      const btnRect = btn.getBoundingClientRect();
      const footerRect = footer.getBoundingClientRect();

      // If footer is coming into view
      if (btnRect.top + scrollTop + btnRect.height >= footerRect.top + scrollTop - 10) {
        btn.style.position = 'absolute';
      }

      // If footer is not near, keep fixed
      if (scrollTop + windowHeight < footerRect.top + scrollTop) {
        btn.style.position = 'fixed';
      }
    };

    document.addEventListener('scroll', onScroll);
    // Initialize visibility/position on mount
    onScroll();
    return () => document.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="upward-container">
      <div className={`upward ${isVisible ? 'is-visible' : 'is-hidden'}`}>
        <button onClick={scrollToTop}>
          <img src="/images/general/circle-arrow-up-solid.svg" alt="Upward arrow" />
        </button>
      </div>
    </div>
  );
}

export default BackToTopButton; 